module.exports = __webpack_public_path__ + "media/images/bg/mosaic/koi-2694512b800b6fceaff597b9533040fa.svg";